import { ProductClassifications } from '@core/enums/product-classifications';

export interface ShoppingCartItem {
  id: string;
  name: string;
  icon: string;
  image: string;
  dueNow: number;
  perMonth: number;
  addedToNextInvoice: number;
  productClassification: ProductClassifications;
  children: ShoppingCartChildItem[];
  isExistingSubscription: boolean;
  connectedToItem: string;
  existingOfferingName: string;
  subscriberIsUpdated: boolean;
  replaceVoiceSimIcc: string;
  replaceDataSimIcc: string;
  replaceTwinSimIcc: string;
}

export class ShoppingCartChildItem {
  id: string;
  name: string;
  icon: string;
  image: string;
  dueNow: number;
  perMonth: number;
  isAdded?: boolean;
  addedToNextInvoice: number;
  isDataSimCard: boolean;
  isTwinSimCard: boolean;
}
